<div class="login_wrapper">
            <img src="/assets/images/logo-mark.svg" class="login_logo" alt="">
<div class="login_content">
    <div class="login_box">


<form [formGroup]="passwordForm">
    <div class="login_box_inner">

        <img src="/assets/images/logo_icon.png" class="login_logo" alt="">
              <p class="welcome_text_login"><span>Welcome to</span>closedcaptions.ai</p>
              <div class="login_control mb_16">
                  <p class="login_password_label">Email Address</p>
                  <input type="text" class="form-control login_form_control" formControlName="email" placeholder="Enter your Email">
              </div>
              <div *ngIf="passwordForm.get('email')?.invalid && passwordForm.get('email')?.touched" class="text-danger">
                Enter a valid email address.
              </div>
              <div class="login_control mb_8">
                  <p class="login_password_label">One Time Password</p>
                  <input type="password" [type]="passwordVisible ? 'text' : 'password'" class="form-control login_form_control" formControlName="password1" placeholder="Enter new password">
                  <i class="fa fa-eye-slash password_eye_login" aria-hidden="true" *ngIf="!passwordVisible"
                      (click)="togglePasswordVisibility()"></i>
                  <i class="fa fa-eye password_eye_login" aria-hidden="true" *ngIf="passwordVisible"
                      (click)="togglePasswordVisibility()"></i>
              </div>
              <div *ngIf="passwordForm.get('password1')?.invalid && passwordForm.get('password1')?.touched"
              class="text-danger">
              One Time Password is required.
            </div>
            
        <div class="login_control mb_24">
            <p class="login_password_label">Create Password</p>
            <input [type]="passwordVisible2==true?'text':'password'" class="form-control login_form_control" formControlName="password" placeholder="Enter new password">
            <i class="fa fa-eye-slash password_eye_login" aria-hidden="true" *ngIf="!passwordVisible2"
                (click)="togglePasswordVisibility2()"></i>
            <i class="fa fa-eye password_eye_login" aria-hidden="true" *ngIf="passwordVisible2"
                (click)="togglePasswordVisibility2()"></i>
        </div>
        <div class="login_control mb_24">
            <p class="login_password_label">Confirm Password</p>
            <input [type]="passwordVisible1==true?'text':'password'" (input)="confirm()" class="form-control login_form_control" formControlName="confirmPassword" placeholder="Enter new password">
            <i class="fa fa-eye-slash password_eye_login" aria-hidden="true" *ngIf="!passwordVisible1"
                (click)="togglePasswordVisibility1()"></i>
            <i class="fa fa-eye password_eye_login" aria-hidden="true" *ngIf="passwordVisible1"
                (click)="togglePasswordVisibility1()"></i>
        </div>
        <div class="password_btn_group password_bottom_pading">
            <a  class="btn password_cancel_btn">Cancel</a>
            <button  class="btn password_next_btn" (click)="updatePassword()" [disabled]="butn || passwordForm.invalid">Change Password</button>
        </div>
    </div></form>
        
        </div>
        </div>